var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVector = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19958 22.3C0.940248 22 0.817785 21.65 0.832192 21.25C0.8466 20.85 0.969063 20.5 1.19958 20.2L11.9619 7.75C12.106 7.58333 12.2501 7.46667 12.3942 7.4C12.5382 7.33333 12.6967 7.3 12.8696 7.3C13.0425 7.3 13.201 7.33333 13.3451 7.4C13.4891 7.46667 13.6332 7.58333 13.7773 7.75L20.0877 15.05L30.5043 3H26.3117C25.9372 3 25.6274 2.85833 25.3825 2.575C25.1375 2.29167 25.0151 1.93333 25.0151 1.5C25.0151 1.06667 25.1375 0.708333 25.3825 0.424999C25.6274 0.141666 25.9372 0 26.3117 0H33.5299C33.9045 0 34.2142 0.141666 34.4591 0.424999C34.7041 0.708333 34.8265 1.06667 34.8265 1.5V9.85C34.8265 10.25 34.7041 10.6 34.4591 10.9C34.2142 11.2 33.9189 11.35 33.5731 11.35C33.2273 11.35 32.9248 11.2 32.6654 10.9C32.4061 10.6 32.2764 10.25 32.2764 9.85V5.2L20.9522 18.3C20.8081 18.4667 20.664 18.5833 20.52 18.65C20.3759 18.7167 20.2174 18.75 20.0445 18.75C19.8716 18.75 19.7131 18.7167 19.5691 18.65C19.425 18.5833 19.2809 18.4667 19.1368 18.3L12.8264 11L3.01492 22.35C2.7844 22.6167 2.48905 22.75 2.12886 22.75C1.76868 22.75 1.45892 22.6 1.19958 22.3Z",
    fill: "#4A3AB1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVector, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vector.64637ae0.svg";
export { ForwardRef as ReactComponent };